import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Skeleton } from '@material-ui/lab';

const styles = theme => ({
  root: {
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16)',
    marginBottom: theme.spacing(1),
    width: '100%',
  },
});

const SkeletonCard = ({
  className,
  classes,
}) => {
  return (
    <Skeleton
      className={classNames(classes.root, className)}
      variant="rect"
      animation="wave"
      height={88}
    />
  );
};

SkeletonCard.defaultProps = {
  className: '',
};

SkeletonCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SkeletonCard);
